module.exports = __webpack_public_path__ + "static/media/M007-account.57a39bf9.svg";